import { avatarAnatomy as parts } from "@chakra-ui/anatomy"
import { isDark, mode, randomColor } from "@chakra-ui/theme-tools"
import type {
  PartsStyleFunction,
  PartsStyleObject,
  SystemStyleFunction,
} from "@chakra-ui/theme-tools"
import { $color, $size } from "@/utils/cssVarUtils"

const baseStyleBadge: SystemStyleFunction = (props) => {
  return {
    borderColor: $color('scene-border'),
    bg: 'white',
    h: '2xl',
    w: '2xl',
  }
}

const baseStyleExcessLabel: SystemStyleFunction = (props) => {
  return {
    bg: $color('bg-input-normal'),
  }
}

const baseStyleContainer: SystemStyleFunction = (props) => {
  const { name, theme } = props
  const bg = name ? randomColor({ string: name }) : "gray.400"
  const isBgDark = isDark(bg)(theme)

  let color = $color('dark-text-normal')
  if (!isBgDark) color = $color('text-normal')

  return {
    bg,
    color,
    border: 'none',
    verticalAlign: "top",
  }
}

const baseStyle: PartsStyleFunction<typeof parts> = (props) => ({
  badge: baseStyleBadge(props),
  excessLabel: baseStyleExcessLabel(props),
  container: baseStyleContainer(props),
})

function getSize(sizeName: string): PartsStyleObject<typeof parts> {
  const size = $size(`${sizeName}`)

  return {
    container: {
      width: size,
      height: size,
      fontSize: `calc(${size} / 2.5)`,
    },
    excessLabel: {
      width: size,
      height: size,
    },
    label: {
      fontSize: `calc(${size} / 2.5)`,
    },
  }
}

const sizes = {
  xs: getSize('md'),
  sm: getSize('4xl'),
  md: getSize('6xl'),
  lg: getSize('8xl'),
  xl: getSize('10xl'),
  '2xl': getSize('11xl'),
  '3xl': getSize('12xl'),
}

const defaultProps = {
  size: "md",
}

export const Avatar = {
  parts: parts.keys,
  baseStyle,
  sizes,
  defaultProps,
}